import './style/siteDocument.scss';

import React from 'react';
import Document from '../../models/documentModel';
import {createErrorMessage} from '../../util/utils';
import {ResponseData} from '@dvrd/fetch';
import {AwesomeIcon, showDialog} from '@dvrd/dvr-controls';
import {IconName} from '@fortawesome/fontawesome-svg-core';
import classNames from 'classnames';

interface Props {
    document: Document;
    loading?: boolean;
}

function getIconName(extension: string): IconName | null {
    if (extension.endsWith('pdf')) return 'file-pdf';
    else if (extension.endsWith('xlsx') || extension.endsWith('xls')) return 'file-excel';
    else if (extension.endsWith('docx')) return 'file-word';
    return null;
}

export default function SiteDocument(props: Props) {
    const {document, loading} = props;

    function onDownloadDocument() {
        document.download((_: Document, success: boolean, data: ResponseData) => {
            if (!success)
                showDialog(createErrorMessage(data.message ?? 'Het downloaden van het bestand is niet gelukt.'),
                    'Download mislukt');
        });
    }

    const iconName = getIconName(document.fileExtension);
    return (
        <div className={classNames('site-document click', loading && 'loading', !!iconName && 'with-icon')}
             onClick={loading ? undefined : onDownloadDocument} title='Downloaden'>
            {!!iconName && <AwesomeIcon name={iconName} className='document-icon'/>}
            <label className={classNames('default-link ul click',
                loading && 'loading')}>{document.label}</label>
        </div>
    );
}

SiteDocument.displayName = 'SiteDocument';